<template>
  <div class="manage" :style="'min-height:'+curHeight+'px'" v-loading.fullscreen.lock="fullscreenLoading" element-loading-text="数据加载中" element-loading-background="rgba(0, 0, 0, 0)" element-loading-spinner="el-icon-loading">
    <div class="header">
      <div class="bg" :style="'background:url('+bg+');background-size:100% 100%;'">
        <div class="headCon">
          <img :src="userData.avatar" />
          <p>{{userData.username}}<b>加入时间:{{userData.createtime}}</b></p>
        </div>
      </div>
      <div class="info">
        <div class="item-list">
          <p>{{total}}</p>
          <p>总收入</p>
        </div>
        <div class="item-list">
          <p>{{dk}}</p>
          <p>已抵扣</p>
        </div>
        <div class="item-list">
          <p>{{total - dk}}</p>
          <p>剩余</p>
        </div>
      </div>
    </div>

    <ul>
      <li v-for="(item,i) in detail">
        <h2><img :src="item.avatar" />{{item.username}}</h2>
        <p>柜锁名称：{{item.title}}</p>
        <p>购买时间：{{item.createtime}}</p>
        <div class="sr">收入{{item.price}}元</div>
        <a @click="qrbh(item.id)" v-if="item.status == 3">确认补货</a>
      </li>
    </ul>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        curHeight:0,
        fullscreenLoading: false,
        baseUrl:'',
        detail:[],
        address:[],
        userData:[],
        remark:'',
        total:0,
        bg:require( '../../assets/images/lock_bg.png'),
        dk:0
      };
    },
    beforeMount() {
      this.baseUrl = this.$host;
    },
    created(){
      this.userData = localStorage.getItem('user') == null ? [] : JSON.parse(localStorage.getItem('user'));
    },
    mounted() {
      this.beforeMount();
      this.getDetail();
    },

    methods: {
      beforeMount:function(){
        var h = document.documentElement.clientHeight || document.body.clientHeight;
        this.curHeight =h; //减去页面上固定高度height
      },
      toPush:function(index,url){
        this.$router.push({
          path:url,
          query:{
            id:index
          }
        })
      },
      qrbh:function(order_id){
        var that = this;
        that.fullscreenLoading = true
        this.axios({
          method:'post',
          url:that.$host+'home/lock/qrbh',
          params:{
            order_id:order_id
          }
        }).then(function(response){
          var res = response.data.data;
          if(response.data.status == 200){
            that.getDetail();
          }
        }).catch(err=>{
          console.log('请求失败:'+err);
          that.fullscreenLoading = false
        });
      },
      getDetail:function(){
        var that = this;
        that.fullscreenLoading = true
        this.axios({
          method:'post',
          url:that.$host+'home/lock/manage',
          params:{
            id:that.userData.id
          }
        }).then(function(response){
          var res = response.data.data;
          that.detail = res.rs;
          that.fullscreenLoading = false
          that.total = res.total
        }).catch(err=>{
          console.log('请求失败:'+err);
          that.fullscreenLoading = false
        });
      },
    }
  };
</script>

<style>
  .el-loading-spinner{
    width:30%;
    background:rgba(0,0,0,0.8);
    left:50%;
    transform: translateX(-50%);
    border-radius:5px;
    padding:15px 0;
    color:#fff;
  }
  .el-loading-spinner i{
    color:#fff;
    font-size:22px
  }
  .el-loading-spinner .el-loading-text{
    color:#fff;
  }
  .el-message-box{
    width:70%
  }
  .manage{
    max-width:640px;
    background:#F7FAFF;
    margin:0 auto;
    padding-bottom:5px;
    padding-top:15px;
  }

  .manage .header{
    width:94%;
    height:160px;
    display:block;
    margin:0 auto;
    background:#fff;
    background: #FFFFFF;
    box-shadow: 0px 0px 10px 0px rgba(47, 120, 255, 0.2);
    border-radius: 10px;
  }
  .manage .header .bg{
    width: 100%;
    height: 100px;
  }
  .manage .header .bg .headCon img{
    margin:15px 0 0 16px;
    padding:2px;
    float:left;
    background:#fff;
    width:70px;
    border-radius: 50%;
  }
  .manage .header .bg .headCon p{
    font-size: 20px;
    font-family: PingFang SC;
    font-weight: bold;
    color: #FFFEFE;
    float:left;
    margin:20px 0 0 10px;
    width:70%
  }
  .manage .header .bg .headCon p b{
    display:block;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #FFFEFE;
    padding-top:10px;
  }

  .manage .header .info{
    width: 100%;
    height:58px;
    display: flex;
    flex-wrap: nowrap;
    justify-content: space-between;
  }
  .manage .header .info .item-list{
    width:33.33%;
    text-align:center;
    position: relative;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: bold;
    color: #96BBFF;
  }
  .manage .header .info .item-list p:first-child{
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: bold;
    color: #2F78FF;
    padding:10px 0 2px 0
  }
  .manage .header .info .item-list:after{
    position: absolute;
    width:1px;
    height:40px;
    content:'';
    right:0;
    top:9px;
    background:#EBF2FF
  }

  .manage .header .info .item-list:last-child:after{
    background:none;
  }

  .manage ul{
    display:block;
    width:94%;
    margin:0 auto;
    margin-top:15px
  }
  .manage ul li{
    display:block;
    width:100%;
    background: #FFFFFF;
    box-shadow: 0px 0px 10px 0px rgba(47, 120, 255, 0.2);
    border-radius: 10px;
    margin-bottom:15px;
    position: relative;
    padding-bottom:15px;
  }
  .manage ul li h2{
    width:92%;
    margin:0 auto;
    font-size:15px;
    padding:15px 0 10px 0;
    letter-spacing: 2px;
    height:30px;
    line-height:30px;
    border-bottom:solid 1px #EBF2FF;
    color:#333;
  }
  .manage ul li h2 img{
    float:left;
    width:30px;
    border-radius: 50%;
    margin-right:8px
  }
  .manage ul li p{
    font-size:15px;
    padding-left:15px;
    color:#999;
    letter-spacing:1px;
    padding-top:10px;
  }
  .manage ul li .point{
    font-size:15px;
    padding-left:15px;
    color:#004aff;
    letter-spacing:1px;
    padding-bottom:15px;
    font-weight:bold
  }
  .manage ul li .sr{
    position: absolute;
    top:20px;
    right:10px;
    color:#0FB144;
    font-size:14px;
    font-weight:bold
  }
  .manage ul li a {
    position: absolute;
    right: 10px;
    bottom: 15px;
    color: #2F78FF;
    border: 1px solid #2F78FF;
    border-radius: 30px;
    width: 83px;
    height: 30px;
    text-align: center;
    line-height: 30px;
    font-weight: 600;
    font-size: 14px;
  }
</style>